const landingPages = {
	styles: {
		title: "Styles",
		content: `
      <style>

    * {
      box-sizing: border-box;
    }

    body {
      margin: 0;
    }

    .gjs-heading {
      margin: 0;
      color: rgba(29, 40, 55, 1);
    }

    .gjs-grid-column {
      flex: 1 1 0%;
      padding: 5px 0;
    }

    .gjs-grid-row {
      display: flex;
      justify-content: center;
      align-items: stretch;
      flex-direction: row;
      min-height: auto;
      padding: 10px 0;
    }

    #iqjl {
      flex: 0 1 auto;
    }

    .gjs-link-box {
      color: inherit;
      display: inline-block;
      vertical-align: top;
      padding: 10px;
      max-width: 100%;
      text-decoration: none;
    }

    .gjs-link {
      vertical-align: top;
      max-width: 100%;
      display: inline-block;
      text-decoration: none;
      color: inherit;
      transition: color 0.3s ease 0s;
    }

    #id7x {
      flex: 0 1 auto;
      display: block;
      padding-left: 10px;
      padding-right: 10px;
    }

    #iffs {
      flex: 0 1 auto;
    }

    #iyd2 {
      align-items: center;
      justify-content: space-between;
      padding-top: 0px;
      padding-bottom: 0px;
      background-color: rgba(255, 255, 255, 0.8);
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;
      backdrop-filter: blur(13px);
      box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.14);
    }

    #i6po {
      justify-content: center;
      position: sticky;
      top: 15px;
      padding-top: 0px;
      padding-bottom: 0px;
      padding-left: 20px;
      padding-right: 20px;
    }

    #itjq {
      width: 100%;
      max-width: 1200px;
    }

    #iucmr {
      display: block;
      padding-top: 0px;
      padding-bottom: 0px;
    }

    #it00l {
      padding-top: 0px;
      padding-bottom: 0px;
    }

    #icfyb {
      padding: 10px;
      font-family: Arial, Helvetica, sans-serif;
      padding-left: 20px;
      padding-right: 20px;
    }

    #irtfd {
      flex: 0 1 auto;
    }

    #i88iz {
      padding: 10px;
      font-family: Arial, Helvetica, sans-serif;
      padding-left: 20px;
      padding-right: 20px;
    }

    #icyzp {
      flex: 0 1 auto;
    }

    #irz7b {
      justify-content: center;
      padding-top: 80px;
      padding-bottom: 80px;
      padding-left: 20px;
      padding-right: 20px;
    }

    #iycz3 {
      max-width: 1200px;
      align-items: center;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    #irjua {
      font-size: 3rem;
      text-align: center;
    }

    #itndw {
      padding: 10px;
      max-width: 750px;
      margin-bottom: 25px;
      text-align: center;
    }

    #i3vvs {
      color: black;
      border-top-left-radius: 35px;
      border-top-right-radius: 35px;
      border-bottom-right-radius: 35px;
      border-bottom-left-radius: 35px;
      max-width: 100%;
      margin-top: 38px;
      margin-right: 38px;
      margin-bottom: 38px;
      margin-left: 38px;
    }

    .text-content {
      line-height: 20px;
    }

    .text-main-content {
      line-height: 30px;
      font-size: 1.2rem;
    }

    #iau9, body {
      font-family: Arial, Helvetica, sans-serif;
    }

    .object-cover {
      filter: none !important;
    }

    #ij2gh {
      font-size: 1.2rem;
      margin-bottom: 15px;
    }

    #igrx8 {
      padding: 10px;
      max-width: 750px;
      margin-bottom: 25px;
      padding-left: 0px;
      padding-right: 0px;
    }

    #i466d {
      color: black;
      border-top-left-radius: 35px;
      border-top-right-radius: 35px;
      border-bottom-right-radius: 35px;
      border-bottom-left-radius: 35px;
      max-width: 100%;
    }

    #imymf {
      max-width: 1200px;
      align-items: center;
      display: flex;
      flex-direction: column;
    }

    #feature-section {
      justify-content: center;
      padding-top: 80px;
      padding-bottom: 80px;
      padding-left: 20px;
      padding-right: 20px;
    }

    #ib541 {
      gap: 100px;
      justify-content: space-between;
    }

    #iz8m8 {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
    }

    #in9ef {
      font-size: 1.5rem;
    }

    #i8isa {
      padding: 10px;
      padding-left: 0px;
      padding-right: 0px;
    }

    #i8w4i {
      max-width: 1200px;
      display: flex;
      flex-direction: column;
    }

    #ioyxg {
      justify-content: center;
      padding-top: 80px;
      padding-bottom: 80px;
      padding-left: 20px;
      padding-right: 20px;
    }

    #iiacm {
      font-size: 2.5rem;
      margin-bottom: 10px;
      max-width: 750px;
    }

    #ixzh1 {
      width: 100%;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 50px;
    }

    .gjs-grid-column.feature-item {
      padding-top: 15px;
      padding-right: 15px;
      padding-bottom: 15px;
      padding-left: 15px;
      display: flex;
      flex-direction: column;
      gap: 15px;
      min-width: 30%;
    }

    #ia21sa {
      padding: 10px;
      max-width: 750px;
      margin-bottom: 70px;
      padding-left: 0px;
      padding-right: 0px;
    }

    #ihap8q {
      font-size: 2.5rem;
      margin-bottom: 10px;
      text-align: center;
    }

    #i6fjjy {
      padding: 10px;
      max-width: 750px;
      margin-bottom: 70px;
      padding-left: 0px;
      padding-right: 0px;
      text-align: center;
    }

    #ia7pcr {
      color: black;
      border-top-left-radius: 100%;
      border-top-right-radius: 100%;
      border-bottom-right-radius: 100%;
      border-bottom-left-radius: 100%;
      max-width: 100%;
      width: 75px;
      border-top-width: 3px;
      border-right-width: 3px;
      border-bottom-width: 3px;
      border-left-width: 3px;
      border-top-style: solid;
      border-right-style: solid;
      border-bottom-style: solid;
      border-left-style: solid;
      border-top-color: rgb(36, 99, 235);
      border-right-color: rgb(36, 99, 235);
      border-bottom-color: rgb(36, 99, 235);
      border-left-color: rgb(36, 99, 235);
    }

    #iqroa4 {
      font-size: 1.5rem;
    }

    #i5k4nf {
      width: 100%;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 50px;
    }

    #infwen {
      max-width: 1200px;
      align-items: center;
      display: flex;
      flex-direction: column;
    }

    #testimonial-section {
      justify-content: center;
      padding-top: 80px;
      padding-bottom: 80px;
      padding-left: 20px;
      padding-right: 20px;
    }

    #inea73 {
      justify-content: space-between;
    }

    .gjs-grid-column.testimonial-item {
      padding-top: 15px;
      padding-right: 15px;
      padding-bottom: 15px;
      padding-left: 15px;
      display: flex;
      flex-direction: column;
      gap: 15px;
      min-width: 45%;
      background-color: rgba(247, 247, 247, 0.23);
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
      align-items: flex-start;
      border-top-width: 1px;
      border-right-width: 1px;
      border-bottom-width: 1px;
      border-left-width: 1px;
      border-top-style: solid;
      border-right-style: solid;
      border-bottom-style: solid;
      border-left-style: solid;
      border-top-color: rgba(0, 0, 0, 0.06);
      border-right-color: rgba(0, 0, 0, 0.06);
      border-bottom-color: rgba(0, 0, 0, 0.06);
      border-left-color: rgba(0, 0, 0, 0.06);
    }

    #idva29 {
      flex: 0 1 auto;
    }

    #i2d7qp {
      width: 100%;
      gap: 20px;
      align-items: center;
    }

    #iaqf2c {
      color: rgba(0, 0, 0, 0.5);
    }

    #it3yug {
      padding: 10px;
      padding-left: 0px;
      padding-right: 0px;
    }

    #i8gt4n {
      padding: 10px;
      padding-left: 0px;
      padding-right: 0px;
    }

    #ixzdlj {
      color: black;
      border-top-left-radius: 100%;
      border-top-right-radius: 100%;
      border-bottom-right-radius: 100%;
      border-bottom-left-radius: 100%;
      max-width: 100%;
      width: 75px;
      border-top-width: 3px;
      border-right-width: 3px;
      border-bottom-width: 3px;
      border-left-width: 3px;
      border-top-color: rgb(36, 99, 235);
      border-right-color: rgb(36, 99, 235);
      border-bottom-color: rgb(36, 99, 235);
      border-left-color: rgb(36, 99, 235);
      border-top-style: solid;
      border-right-style: solid;
      border-bottom-style: solid;
      border-left-style: solid;
    }

    #inucqu {
      flex: 0 1 auto;
    }

    #i04ztt {
      font-size: 1.5rem;
    }

    #ia9ts3 {
      color: rgba(0, 0, 0, 0.5);
    }

    #ish0zj {
      width: 100%;
      gap: 20px;
      align-items: center;
    }

    #idndjn {
      justify-content: space-between;
    }

    #ilriti {
      max-width: 1200px;
      display: flex;
      flex-direction: column;
    }

    #iv3be5 {
      justify-content: center;
      padding-top: 80px;
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 80px;
    }

    #im0rle {
      flex-direction: column;
    }

    #iih6cv {
      display: block;
      padding-top: 0px;
      padding-bottom: 0px;
    }

    #iotp6j {
      align-self: center;
    }

    #it6g1v {
      padding: 10px;
      text-align: center;
      font-size: 0.8rem;
      margin-top: 20px;
      opacity: 75%;
    }

    #ij7g8t {
      display: block;
    }

    #ipjdtn {
      display: block;
    }

    #ikj01e {
      display: block;
    }

    #i1hx7l {
      display: flex;
      gap: 30px;
      flex: 0 1 auto;
      justify-content: center;
      margin-top: 30px;
      margin-bottom: 30px;
    }

    #i2sl68 {
      display: block;
    }

    .gjs-button {
      vertical-align: top;
      max-width: 100%;
      display: inline-block;
      text-decoration: none;
      color: white;
      padding-right: 15px;
      padding-bottom: 10px;
      padding-left: 15px;
      background-color: rgb(36, 99, 235);
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
      padding-top: 10px;
      font-size: 1.1rem;
      text-align: center;
    }

    .gjs-text-blue {
      color: rgb(36, 99, 235);
    }

    #ism014 {
      font-size: 2.5rem;
    }

    #in201n {
      padding: 10px;
      max-width: 750px;
      margin-bottom: 35px;
      padding-left: 0px;
      padding-right: 0px;
      text-align: center;
      margin-top: 35px;
    }

    #ik2rdi {
      max-width: 1200px;
      align-items: center;
      display: flex;
      flex-direction: column;
      padding-top: 50px;
      padding-right: 50px;
      padding-bottom: 50px;
      padding-left: 50px;
      border-top-left-radius: 50px;
      border-top-right-radius: 50px;
      border-bottom-right-radius: 50px;
      border-bottom-left-radius: 50px;
      border-top-width: 1px;
      border-right-width: 1px;
      border-bottom-width: 1px;
      border-left-width: 1px;
      border-top-style: solid;
      border-right-style: solid;
      border-bottom-style: solid;
      border-left-style: solid;
      border-top-color: rgba(0, 0, 0, 0.06);
      border-right-color: rgba(0, 0, 0, 0.06);
      border-bottom-color: rgba(0, 0, 0, 0.06);
      border-left-color: rgba(0, 0, 0, 0.06);
      background-image: radial-gradient(515px at 50% 141%, rgba(35, 98, 235, 0.22) 10%, white 90%);
      background-position: 0px 0px;
      background-size: 100% 100%;
      background-repeat: repeat;
      background-attachment: scroll;
      background-origin: padding-box;
      box-shadow: 0px 10px 15px 0 rgba(0, 0, 0, 0.07);
    }

    #iz29ek {
      justify-content: center;
      padding-top: 80px;
      padding-bottom: 80px;
      padding-left: 20px;
      padding-right: 20px;
    }

    .gjs-link:hover {
      color: rgb(36, 99, 235);
      text-decoration: underline;
    }

    .gjs-icon {
      display: inline-block;
      text-decoration: none;
      color: inherit;
      vertical-align: middle;
      fill: currentColor;
      width: 50px;
      height: 50px;
    }

    #irfl3k {
      width: 196px;
      height: 41px;
    }

    #ip6zoj {
      width: 213px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    #ihs4lb {
      font-size: 1.2rem;
      margin-bottom: 15px;
    }

    .gjs-icon.gjs-feature-icon {
      padding-top: 10px;
      padding-right: 10px;
      padding-bottom: 10px;
      padding-left: 10px;
      background-color: rgb(36, 99, 235);
      color: white;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    #ieu6p6 {
      font-size: 1.5rem;
    }

    #izqkf7 {
      padding: 10px;
      padding-left: 0px;
      padding-right: 0px;
    }

    #ica43q {
      font-size: 1.5rem;
    }

    #ickn3f {
      padding: 10px;
      padding-left: 0px;
      padding-right: 0px;
    }

    #i83vu9 {
      font-size: 2.5rem;
      text-align: center;
    }

    #infmy1 {
      padding: 10px;
      font-family: Arial, Helvetica, sans-serif;
      padding-left: 20px;
      padding-right: 20px;
    }

    @media (max-width: 992px) {
      .gjs-grid-row {
        flex-direction: column;
      }

      #i2d7qp {
        flex-direction: row;
      }

      #ish0zj {
        flex-direction: row;
      }

      #iyd2 {
        flex-direction: row;
      }

      #it00l {
        flex-direction: row;
      }
    }

    @media (max-width: 768px) {
      #iffs {
        display: none;
      }
    }

    @media (max-width: 480px) {
      #irfl3k {
        width: 116px;
        height: 24px;
      }
    }
  </style>
    `,
	},
	landingPage1: {
		title: "Landing Page 1",
		content: `

<body id="iau9">
    <style>
    * {
      box-sizing: border-box;
    }

    body {
      margin: 0;
    }

    .gjs-heading {
      margin: 0;
      color: rgba(29, 40, 55, 1);
    }

    .gjs-grid-column {
      flex: 1 1 0%;
      padding: 5px 0;
    }

    .gjs-grid-row {
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      flex-direction: row;
      min-height: auto;
      padding: 10px 0;
    }

    #iqjl {
      flex: 0 1 auto;
    }

    .gjs-link-box {
      color: inherit;
      display: inline-block;
      vertical-align: top;
      padding: 10px;
      max-width: 100%;
      text-decoration: none;
    }

    .gjs-link {
      vertical-align: top;
      max-width: 100%;
      display: inline-block;
      text-decoration: none;
      color: inherit;
      transition: color 0.3s ease 0s;
    }

    #id7x {
      flex: 0 1 auto;
      display: block;
      padding-left: 10px;
      padding-right: 10px;
    }

    #iffs {
      flex: 0 1 auto;
    }

    #iyd2 {
      align-items: center;
      justify-content: space-between;
      padding-top: 0px;
      padding-bottom: 0px;
      background-color: rgba(255, 255, 255, 0.8);
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;
      backdrop-filter: blur(13px);
      box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.14);
    }

    #i6po {
      justify-content: center;
      position: sticky;
      top: 15px;
      padding-top: 0px;
      padding-bottom: 0px;
      padding-left: 20px;
      padding-right: 20px;
    }

    #itjq {
      width: 100%;
      max-width: 1200px;
    }

    #iucmr {
      display: block;
      padding-top: 0px;
      padding-bottom: 0px;
    }

    #it00l {
      padding-top: 0px;
      padding-bottom: 0px;
    }

    #icfyb {
      padding: 10px;
      font-family: Arial, Helvetica, sans-serif;
      padding-left: 20px;
      padding-right: 20px;
    }

    #irtfd {
      flex: 0 1 auto;
    }

    #i88iz {
      padding: 10px;
      font-family: Arial, Helvetica, sans-serif;
      padding-left: 20px;
      padding-right: 20px;
    }

    #icyzp {
      flex: 0 1 auto;
    }

    #irz7b {
      justify-content: center;
      padding-top: 80px;
      padding-bottom: 80px;
      padding-left: 20px;
      padding-right: 20px;
    }

    #iycz3 {
      max-width: 1200px;
      align-items: center;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    #irjua {
      font-size: 3rem;
      text-align: center;
    }

    #itndw {
      padding: 10px;
      max-width: 750px;
      margin-bottom: 25px;
      text-align: center;
    }

    #i3vvs {
      color: black;
      border-top-left-radius: 35px;
      border-top-right-radius: 35px;
      border-bottom-right-radius: 35px;
      border-bottom-left-radius: 35px;
      max-width: 100%;
      margin-top: 38px;
      margin-right: 38px;
      margin-bottom: 38px;
      margin-left: 38px;
    }

    .text-content {
      line-height: 20px;
    }

    .text-main-content {
      line-height: 30px;
      font-size: 1.2rem;
    }

    #iau9, body {
      font-family: Arial, Helvetica, sans-serif;
      background-image: linear-gradient(180deg, rgba(59, 130, 245, 0.11), white 14%);
      background-position: 0px 0px;
      background-size: 100% 100%;
      background-repeat: repeat;
      background-attachment: scroll;
      background-origin: padding-box;
      color: #475569;
    }

    #ij2gh {
      font-size: 1.2rem;
      margin-bottom: 15px;
    }

    #igrx8 {
      padding: 10px;
      max-width: 750px;
      margin-bottom: 25px;
      padding-left: 0px;
      padding-right: 0px;
    }

    #i466d {
      color: black;
      border-top-left-radius: 35px;
      border-top-right-radius: 35px;
      border-bottom-right-radius: 35px;
      border-bottom-left-radius: 35px;
      max-width: 100%;
    }

    #imymf {
      max-width: 1200px;
      align-items: center;
      display: flex;
      flex-direction: column;
    }

    #feature-section {
      justify-content: center;
      padding-top: 80px;
      padding-bottom: 80px;
      padding-left: 20px;
      padding-right: 20px;
    }

    #ib541 {
      gap: 100px;
      justify-content: space-between;
    }

    #iz8m8 {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
    }

    #in9ef {
      font-size: 1.5rem;
    }

    #i8isa {
      padding: 10px;
      padding-left: 0px;
      padding-right: 0px;
    }

    #i8w4i {
      max-width: 1200px;
      display: flex;
      flex-direction: column;
    }

    #ioyxg {
      justify-content: center;
      padding-top: 80px;
      padding-bottom: 80px;
      padding-left: 20px;
      padding-right: 20px;
    }

    #iiacm {
      font-size: 2.5rem;
      margin-bottom: 10px;
      max-width: 750px;
    }

    #ixzh1 {
      width: 100%;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 50px;
    }

    .gjs-grid-column.feature-item {
      padding-top: 15px;
      padding-right: 15px;
      padding-bottom: 15px;
      padding-left: 15px;
      display: flex;
      flex-direction: column;
      gap: 15px;
      min-width: 30%;
    }

    #ia21sa {
      padding: 10px;
      max-width: 750px;
      margin-bottom: 70px;
      padding-left: 0px;
      padding-right: 0px;
    }

    #ihap8q {
      font-size: 2.5rem;
      margin-bottom: 10px;
      text-align: center;
    }

    #i6fjjy {
      padding: 10px;
      max-width: 750px;
      margin-bottom: 70px;
      padding-left: 0px;
      padding-right: 0px;
      text-align: center;
    }

    #ia7pcr {
      color: black;
      border-top-left-radius: 100%;
      border-top-right-radius: 100%;
      border-bottom-right-radius: 100%;
      border-bottom-left-radius: 100%;
      max-width: 100%;
      width: 75px;
      border-top-width: 3px;
      border-right-width: 3px;
      border-bottom-width: 3px;
      border-left-width: 3px;
      border-top-style: solid;
      border-right-style: solid;
      border-bottom-style: solid;
      border-left-style: solid;
      border-top-color: rgb(36, 99, 235);
      border-right-color: rgb(36, 99, 235);
      border-bottom-color: rgb(36, 99, 235);
      border-left-color: rgb(36, 99, 235);
    }

    #iqroa4 {
      font-size: 1.5rem;
    }

    #i5k4nf {
      width: 100%;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 50px;
    }

    #infwen {
      max-width: 1200px;
      align-items: center;
      display: flex;
      flex-direction: column;
    }

    #testimonial-section {
      justify-content: center;
      padding-top: 80px;
      padding-bottom: 80px;
      padding-left: 20px;
      padding-right: 20px;
    }

    #inea73 {
      justify-content: space-between;
    }

    .gjs-grid-column.testimonial-item {
      padding-top: 15px;
      padding-right: 15px;
      padding-bottom: 15px;
      padding-left: 15px;
      display: flex;
      flex-direction: column;
      gap: 15px;
      min-width: 45%;
      background-color: rgba(247, 247, 247, 0.23);
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
      align-items: flex-start;
      border-top-width: 1px;
      border-right-width: 1px;
      border-bottom-width: 1px;
      border-left-width: 1px;
      border-top-style: solid;
      border-right-style: solid;
      border-bottom-style: solid;
      border-left-style: solid;
      border-top-color: rgba(0, 0, 0, 0.06);
      border-right-color: rgba(0, 0, 0, 0.06);
      border-bottom-color: rgba(0, 0, 0, 0.06);
      border-left-color: rgba(0, 0, 0, 0.06);
    }

    #idva29 {
      flex: 0 1 auto;
    }

    #i2d7qp {
      width: 100%;
      gap: 20px;
      align-items: center;
    }

    #iaqf2c {
      color: rgba(0, 0, 0, 0.5);
    }

    #it3yug {
      padding: 10px;
      padding-left: 0px;
      padding-right: 0px;
    }

    #i8gt4n {
      padding: 10px;
      padding-left: 0px;
      padding-right: 0px;
    }

    #ixzdlj {
      color: black;
      border-top-left-radius: 100%;
      border-top-right-radius: 100%;
      border-bottom-right-radius: 100%;
      border-bottom-left-radius: 100%;
      max-width: 100%;
      width: 75px;
      border-top-width: 3px;
      border-right-width: 3px;
      border-bottom-width: 3px;
      border-left-width: 3px;
      border-top-color: rgb(36, 99, 235);
      border-right-color: rgb(36, 99, 235);
      border-bottom-color: rgb(36, 99, 235);
      border-left-color: rgb(36, 99, 235);
      border-top-style: solid;
      border-right-style: solid;
      border-bottom-style: solid;
      border-left-style: solid;
    }

    #inucqu {
      flex: 0 1 auto;
    }

    #i04ztt {
      font-size: 1.5rem;
    }

    #ia9ts3 {
      color: rgba(0, 0, 0, 0.5);
    }

    #ish0zj {
      width: 100%;
      gap: 20px;
      align-items: center;
    }

    #idndjn {
      justify-content: space-between;
    }

    #ilriti {
      max-width: 1200px;
      display: flex;
      flex-direction: column;
    }

    #iv3be5 {
      justify-content: center;
      padding-top: 80px;
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 80px;
    }

    #im0rle {
      flex-direction: column;
    }

    #iih6cv {
      display: block;
      padding-top: 0px;
      padding-bottom: 0px;
    }

    #iotp6j {
      align-self: center;
    }

    #it6g1v {
      padding: 10px;
      text-align: center;
      font-size: 0.8rem;
      margin-top: 20px;
      opacity: 75%;
    }

    #ij7g8t {
      display: block;
    }

    #ipjdtn {
      display: block;
    }

    #ikj01e {
      display: block;
    }

    #i1hx7l {
      display: flex;
      gap: 30px;
      flex: 0 1 auto;
      justify-content: center;
      margin-top: 30px;
      margin-bottom: 30px;
    }

    #i2sl68 {
      display: block;
    }

    .gjs-button {
      vertical-align: top;
      max-width: 100%;
      display: inline-block;
      text-decoration: none;
      color: white;
      padding-right: 15px;
      padding-bottom: 10px;
      padding-left: 15px;
      background-color: rgb(36, 99, 235);
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
      padding-top: 10px;
      font-size: 1.1rem;
      text-align: center;
    }

    .gjs-text-blue {
      color: rgb(36, 99, 235);
    }

    #ism014 {
      font-size: 2.5rem;
    }

    #in201n {
      padding: 10px;
      max-width: 750px;
      margin-bottom: 35px;
      padding-left: 0px;
      padding-right: 0px;
      text-align: center;
      margin-top: 35px;
    }

    #ik2rdi {
      max-width: 1200px;
      align-items: center;
      display: flex;
      flex-direction: column;
      padding-top: 50px;
      padding-right: 50px;
      padding-bottom: 50px;
      padding-left: 50px;
      border-top-left-radius: 50px;
      border-top-right-radius: 50px;
      border-bottom-right-radius: 50px;
      border-bottom-left-radius: 50px;
      border-top-width: 1px;
      border-right-width: 1px;
      border-bottom-width: 1px;
      border-left-width: 1px;
      border-top-style: solid;
      border-right-style: solid;
      border-bottom-style: solid;
      border-left-style: solid;
      border-top-color: rgba(0, 0, 0, 0.06);
      border-right-color: rgba(0, 0, 0, 0.06);
      border-bottom-color: rgba(0, 0, 0, 0.06);
      border-left-color: rgba(0, 0, 0, 0.06);
      background-image: radial-gradient(515px at 50% 141%, rgba(35, 98, 235, 0.22) 10%, white 90%);
      background-position: 0px 0px;
      background-size: 100% 100%;
      background-repeat: repeat;
      background-attachment: scroll;
      background-origin: padding-box;
      box-shadow: 0px 10px 15px 0 rgba(0, 0, 0, 0.07);
    }

    #iz29ek {
      justify-content: center;
      padding-top: 80px;
      padding-bottom: 80px;
      padding-left: 20px;
      padding-right: 20px;
    }

    .gjs-link:hover {
      color: rgb(36, 99, 235);
      text-decoration: underline;
    }

    .gjs-icon {
      display: inline-block;
      text-decoration: none;
      color: inherit;
      vertical-align: middle;
      fill: currentColor;
      width: 50px;
      height: 50px;
    }

    #irfl3k {
      width: 196px;
      height: 41px;
    }

    #ip6zoj {
      width: 213px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    #ihs4lb {
      font-size: 1.2rem;
      margin-bottom: 15px;
    }

    .gjs-icon.gjs-feature-icon {
      padding-top: 10px;
      padding-right: 10px;
      padding-bottom: 10px;
      padding-left: 10px;
      background-color: rgb(36, 99, 235);
      color: white;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    #ieu6p6 {
      font-size: 1.5rem;
    }

    #izqkf7 {
      padding: 10px;
      padding-left: 0px;
      padding-right: 0px;
    }

    #ica43q {
      font-size: 1.5rem;
    }

    #ickn3f {
      padding: 10px;
      padding-left: 0px;
      padding-right: 0px;
    }

    #i83vu9 {
      font-size: 2.5rem;
      text-align: center;
    }

    #infmy1 {
      padding: 10px;
      font-family: Arial, Helvetica, sans-serif;
      padding-left: 20px;
      padding-right: 20px;
    }

    @media (max-width: 992px) {
      .gjs-grid-row {
        flex-direction: column;
      }

      #i2d7qp {
        flex-direction: row;
      }

      #ish0zj {
        flex-direction: row;
      }

      #iyd2 {
        flex-direction: row;
      }

      #it00l {
        flex-direction: row;
      }
    }

    @media (max-width: 768px) {
      #iffs {
        display: none;
      }
    }

    @media (max-width: 480px) {
      #irfl3k {
        width: 116px;
        height: 24px;
      }
    }
  </style>

  <div id="i6po" class="gjs-grid-row">
    <div id="itjq" class="gjs-grid-column">
      <div id="iyd2" class="gjs-grid-row">
        <div id="iqjl" class="gjs-grid-column"><a id="iucmr" href="/" class="gjs-link-box">
            <div data-type-icon id="irfl3k" class="gjs-icon">
                <img id="ihs4lb" src="https://cdn.pixabay.com/photo/2023/03/06/13/58/brand-7833518_1280.png" width="100" height="40" style="object-fit: contain;"/>
            </div>
          </a></div>
        <div id="iffs" class="gjs-grid-column">
          <div id="it00l" class="gjs-grid-row">
            <div id="irtfd" class="gjs-grid-column"><a id="icfyb" href="#feature-section" class="gjs-link">About</a><a
                href="#feature-section" id="infmy1" class="gjs-link">Features</a></div>
            <div id="icyzp" class="gjs-grid-column"><a id="i88iz" href="#testimonial-section"
                class="gjs-link">Testimonials</a></div>
          </div>
        </div>
        <div id="id7x" class="gjs-grid-column"><a id="i1mew" href="" class="gjs-button">Join Waitlist</a></div>
      </div>
    </div>
  </div>
  <div id="irz7b" class="gjs-grid-row">
    <div id="iycz3" class="gjs-grid-column">
      <h1 id="irjua" class="gjs-heading">Insert Hero <span id="i4jn1p" class="gjs-text-blue">text here</span></h1>
      <div id="itndw" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua.<br/></div><a id="iar3s" class="gjs-button">Join
        Waitlist</a><img id="i3vvs" src="https://images.pexels.com/photos/7078666/pexels-photo-7078666.jpeg?auto=compress&cs=tinysrgb&w=800&dpr=2"/>
    </div>
  </div>
  <div id="feature-section" class="gjs-grid-row">
    <div id="imymf" class="gjs-grid-column">
      <div id="ib541" class="gjs-grid-row">
        <div id="iz8m8" class="gjs-grid-column">
          <h4 id="ij2gh" class="gjs-heading gjs-text-blue">Feature One text</h4>
          <h2 id="ism014" class="gjs-heading">Feature Text</h2>
          <div id="igrx8" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.</div><a id="iqx3z1" class="gjs-button">Getting
            Started</a>
        </div>
        <div id="iepks" class="gjs-grid-column"><img src="https://images.pexels.com/photos/2121640/pexels-photo-2121640.jpeg?auto=compress&cs=tinysrgb&w=500&dpr=2" id="i466d"/>
        </div>
      </div>
    </div>
  </div>
  <div id="ioyxg" class="gjs-grid-row">
    <div id="i8w4i" class="gjs-grid-column">
      <h4 id="ihs4lb" class="gjs-heading gjs-text-blue">More Features</h4>
      <h2 id="iiacm" class="gjs-heading">Put here the text describing why your features are
        <span id="icxfor" class="gjs-text-blue">so amazing</span></h2>
      <div id="ia21sa" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua.</div>
      <div id="ixzh1" class="gjs-grid-row">
        <div id="ilpi3" class="gjs-grid-column feature-item">
          <div data-type-icon id="ipmqo6" class="gjs-icon gjs-feature-icon"><svg viewBox="0 0 24 24">
              <path
                d="M16 9h3l-5 7m-4-7h4l-2 8M5 9h3l2 7m5-12h2l2 3h-3m-5-3h2l1 3h-4M7 4h2L8 7H5m1-5L2 8l10 14L22 8l-4-6H6z">
              </path>
            </svg></div>
          <h3 id="in9ef" class="gjs-heading">Feature text</h3>
          <div id="i8isa" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
        </div>
        <div id="ic57kq" class="gjs-grid-column feature-item">
          <div data-type-icon id="ibdusm" class="gjs-icon gjs-feature-icon"><svg viewBox="0 0 24 24">
              <path
                d="M16 9h3l-5 7m-4-7h4l-2 8M5 9h3l2 7m5-12h2l2 3h-3m-5-3h2l1 3h-4M7 4h2L8 7H5m1-5L2 8l10 14L22 8l-4-6H6z">
              </path>
            </svg></div>
          <h3 id="ica43q" class="gjs-heading">Feature text</h3>
          <div id="ickn3f" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
        </div>
        <div id="idv32l" class="gjs-grid-column feature-item">
          <div data-type-icon id="ipmept" class="gjs-icon gjs-feature-icon"><svg viewBox="0 0 24 24">
              <path
                d="M16 9h3l-5 7m-4-7h4l-2 8M5 9h3l2 7m5-12h2l2 3h-3m-5-3h2l1 3h-4M7 4h2L8 7H5m1-5L2 8l10 14L22 8l-4-6H6z">
              </path>
            </svg></div>
          <h3 id="ieu6p6" class="gjs-heading">Feature text</h3>
          <div id="izqkf7" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
        </div>
      </div>
    </div>
  </div>
  <div id="testimonial-section" class="gjs-grid-row">
    <div id="infwen" class="gjs-grid-column">
      <h2 id="ihap8q" class="gjs-heading">Testimonial section</h2>
      <div id="i6fjjy" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua.</div>
      <div id="i5k4nf" class="gjs-grid-row">
        <div id="inea73" class="gjs-grid-column testimonial-item">
          <div id="i2d7qp" class="gjs-grid-row">
            <div id="idva29" class="gjs-grid-column"><img src="https://source.unsplash.com/random/200x200/?profile,person,business" id="ia7pcr"/>
            </div>
            <div id="i4djop" class="gjs-grid-column">
              <h4 id="iqroa4" class="gjs-heading">Full name</h4>
              <div id="iaqf2c" class="text-main-content">Role / Company</div>
            </div>
          </div>
          <div id="it3yug" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
        </div>
        <div id="idndjn" class="gjs-grid-column testimonial-item">
          <div id="ish0zj" class="gjs-grid-row">
            <div id="inucqu" class="gjs-grid-column"><img src="https://source.unsplash.com/random/200x200/?profile,person,business" id="ixzdlj"/>
            </div>
            <div id="iuk8ib" class="gjs-grid-column">
              <h4 id="i04ztt" class="gjs-heading">Full name</h4>
              <div id="ia9ts3" class="text-main-content">Role / Company</div>
            </div>
          </div>
          <div id="i8gt4n" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
        </div>
      </div>
    </div>
  </div>
  <div id="iz29ek" class="gjs-grid-row">
    <div id="ik2rdi" class="gjs-grid-column">
      <h2 id="i83vu9" class="gjs-heading">Put here your description <br/>for
        <span id="i7owfh" class="gjs-text-blue">this section</span></h2>
      <div id="in201n" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua.<br/></div><a id="iwgwt5" class="gjs-button">Join
        Waitlist</a>
    </div>
  </div>
  <div id="iv3be5" class="gjs-grid-row">
    <div id="ilriti" class="gjs-grid-column">
      <div id="im0rle" class="gjs-grid-row">
        <div id="iotp6j" class="gjs-grid-column"><a href="/" id="iih6cv" class="gjs-link-box">
            <div data-type-icon id="ip6zoj" class="gjs-icon">
            <img id="ihs4lb" src="https://cdn.pixabay.com/photo/2023/03/06/13/58/brand-7833518_1280.png" width="100" height="40" style="object-fit: contain;"/>
            </div>
          </a></div>
        <div id="i1hx7l" class="gjs-grid-column"><a id="ij7g8t" title="" href="##" class="gjs-link">Pricing<br/></a><a
            id="ipjdtn" href="##" class="gjs-link">Terms &amp; Conditions<br/></a><a id="ikj01e" href="##"
            class="gjs-link">Refund Policy<br/></a><a id="i2sl68" href="##" class="gjs-link">Contact Us<br/></a></div>
      </div>
      <div id="it6g1v" class="gjs-text-blue">Copyright © YEAR Company name</div>
    </div>
  </div>
</body>
	`,
	},
	landingPage2: {
		title: "Landing Page 2",
		content: `
        <body>
  <header id="i954" class="header-banner">
    <div class="container-width">
      <div class="logo-container">
        <div class="logo">GrapesJS
        </div>
      </div>
      <nav class="menu">
        <div class="menu-item">BUILDER
        </div>
        <div class="menu-item">TEMPLATE
        </div>
        <div class="menu-item">WEB
        </div>
      </nav>
      <div class="clearfix">
      </div>
      <div class="lead-title">Build your templates without coding
      </div>
      <div class="sub-lead-title">All text blocks could be edited easily with double clicking on it. You can create new text blocks with the command from the left panel
      </div>
      <div id="iu1zw" class="lead-btn">Hover me
      </div>
    </div>
  </header>
  <section class="flex-sect">
    <div class="container-width">
      <div class="flex-title">Flex is the new black
      </div>
      <div class="flex-desc">With flexbox system you're able to build complex layouts easily and with free responsivity
      </div>
      <div class="cards">
        <div class="card">
          <div class="card-header">
          </div>
          <div class="card-body">
            <div class="card-title">Title one
            </div>
            <div class="card-sub-title">Subtitle one
            </div>
            <div class="card-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header ch2">
          </div>
          <div class="card-body">
            <div class="card-title">Title two
            </div>
            <div class="card-sub-title">Subtitle two
            </div>
            <div class="card-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header ch3">
          </div>
          <div class="card-body">
            <div class="card-title">Title three
            </div>
            <div class="card-sub-title">Subtitle three
            </div>
            <div class="card-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header ch4">
          </div>
          <div class="card-body">
            <div class="card-title">Title four
            </div>
            <div class="card-sub-title">Subtitle four
            </div>
            <div class="card-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header ch5">
          </div>
          <div class="card-body">
            <div class="card-title">Title five
            </div>
            <div class="card-sub-title">Subtitle five
            </div>
            <div class="card-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header ch6">
          </div>
          <div class="card-body">
            <div class="card-title">Title six
            </div>
            <div class="card-sub-title">Subtitle six
            </div>
            <div class="card-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="am-sect">
    <div class="container-width">
      <div class="am-container">
        <img src="/assets/images/demos/phone-app.png" class="img-phone"/>
        <div class="am-content">
          <div class="am-pre">ASSET MANAGER
          </div>
          <div class="am-title">Manage your images with Asset Manager
          </div>
          <div class="am-desc">You can create image blocks with the command from the left panel and edit them with double click
          </div>
          <div class="am-post">Image uploading is not allowed in this demo
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="blk-sect">
    <div class="container-width">
      <div class="blk-title">Blocks
      </div>
      <div class="blk-desc">Each element in HTML page could be seen as a block. On the left panel you could find different kind of blocks that you can create, move and style
      </div>
      <div class="price-cards">
        <div class="price-card-cont">
          <div class="price-card">
            <div class="pc-title">Starter
            </div>
            <div class="pc-desc">Some random list
            </div>
            <div class="pc-feature odd-feat">+ Starter feature 1
            </div>
            <div class="pc-feature">+ Starter feature 2
            </div>
            <div class="pc-feature odd-feat">+ Starter feature 3
            </div>
            <div class="pc-feature">+ Starter feature 4
            </div>
            <div class="pc-amount odd-feat">$ 9,90/mo
            </div>
          </div>
        </div>
        <div class="price-card-cont">
          <div class="price-card pc-regular">
            <div class="pc-title">Regular
            </div>
            <div class="pc-desc">Some random list
            </div>
            <div class="pc-feature odd-feat">+ Regular feature 1
            </div>
            <div class="pc-feature">+ Regular feature 2
            </div>
            <div class="pc-feature odd-feat">+ Regular feature 3
            </div>
            <div class="pc-feature">+ Regular feature 4
            </div>
            <div class="pc-amount odd-feat">$ 19,90/mo
            </div>
          </div>
        </div>
        <div class="price-card-cont">
          <div class="price-card pc-enterprise">
            <div class="pc-title">Enterprise
            </div>
            <div class="pc-desc">Some random list
            </div>
            <div class="pc-feature odd-feat">+ Enterprise feature 1
            </div>
            <div class="pc-feature">+ Enterprise feature 2
            </div>
            <div class="pc-feature odd-feat">+ Enterprise feature 3
            </div>
            <div class="pc-feature">+ Enterprise feature 4
            </div>
            <div class="pc-amount odd-feat">$ 29,90/mo
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="bdg-sect">
    <div class="container-width">
      <h1 class="bdg-title">The team
      </h1>
      <div class="badges">
        <div class="badge">
          <div class="badge-header">
          </div>
          <img src="/assets/images/demos/team1.jpg" class="badge-avatar"/>
          <div class="badge-body">
            <div class="badge-name">Adam Smith
            </div>
            <div class="badge-role">CEO
            </div>
            <div class="badge-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ipsum dolor sit
            </div>
          </div>
          <div class="badge-foot">
            <span class="badge-link">f</span>
            <span class="badge-link">t</span>
            <span class="badge-link">ln</span>
          </div>
        </div>
        <div class="badge">
          <div class="badge-header">
          </div>
          <img src="/assets/images/demos/team2.jpg" class="badge-avatar"/>
          <div class="badge-body">
            <div class="badge-name">John Black
            </div>
            <div class="badge-role">Software Engineer
            </div>
            <div class="badge-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ipsum dolor sit
            </div>
          </div>
          <div class="badge-foot">
            <span class="badge-link">f</span>
            <span class="badge-link">t</span>
            <span class="badge-link">ln</span>
          </div>
        </div>
        <div class="badge">
          <div class="badge-header">
          </div>
          <img src="/assets/images/demos/team3.jpg" class="badge-avatar"/>
          <div class="badge-body">
            <div class="badge-name">Jessica White
            </div>
            <div class="badge-role">Web Designer
            </div>
            <div class="badge-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ipsum dolor sit
            </div>
          </div>
          <div class="badge-foot">
            <span class="badge-link">f</span>
            <span class="badge-link">t</span>
            <span class="badge-link">ln</span>
          </div>
        </div>
      </div>
    </div>
  </section>
  <footer class="footer-under">
    <div class="container-width">
      <div class="footer-container">
        <div class="foot-lists">
          <div class="foot-list">
            <div class="foot-list-title">About us
            </div>
            <div class="foot-list-item">Contact
            </div>
            <div class="foot-list-item">Events
            </div>
            <div class="foot-list-item">Company
            </div>
            <div class="foot-list-item">Jobs
            </div>
            <div class="foot-list-item">Blog
            </div>
          </div>
          <div class="foot-list">
            <div class="foot-list-title">Services
            </div>
            <div class="foot-list-item">Education
            </div>
            <div class="foot-list-item">Partner
            </div>
            <div class="foot-list-item">Community
            </div>
            <div class="foot-list-item">Forum
            </div>
            <div class="foot-list-item">Download
            </div>
            <div class="foot-list-item">Upgrade
            </div>
          </div>
          <div class="clearfix">
          </div>
        </div>
        <div class="form-sub">
          <div class="foot-form-cont">
            <div class="foot-form-title">Subscribe
            </div>
            <div class="foot-form-desc">Subscribe to our newsletter to receive exclusive offers and the latest news
            </div>
            <input type="text" name="name" placeholder="Name" class="sub-input"/>
            <input type="text" name="email" placeholder="Email" class="sub-input"/>
            <button type="button" class="sub-btn">Submit</button>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="container-width">
        <div class="made-with">
          made with GrapesJS
        </div>
        <div class="foot-social-btns">facebook twitter linkedin mail
        </div>
        <div class="clearfix">
        </div>
      </div>
    </div>
  </footer>
</body>
<style>* {
  box-sizing: border-box;
  }
  body {
    margin: 0;
  }
  *{
    box-sizing:border-box;
  }
  body{
    margin:0;
  }
  .clearfix{
    clear:both;
  }
  .header-banner{
    padding-top:35px;
    padding-bottom:100px;
    color:#ffffff;
    font-family:Helvetica, serif;
    font-weight:100;
    background-image:url("/assets/images/demos/bg-gr-v.png"), url("/assets/images/demos/work-desk.jpg");
    background-attachment:scroll, scroll;
    background-position:left top, center center;
    background-repeat:repeat-y, no-repeat;
    background-size:contain, cover;
  }
  .container-width{
    width:90%;
    max-width:1150px;
    margin:0 auto;
  }
  .logo-container{
    float:left;
    width:50%;
  }
  .logo{
    background-color:#fff;
    border-radius:5px;
    width:130px;
    padding:10px;
    min-height:30px;
    text-align:center;
    line-height:30px;
    color:#4d114f;
    font-size:23px;
  }
  .menu{
    float:right;
    width:50%;
  }
  .menu-item{
    float:right;
    font-size:15px;
    color:#eee;
    width:130px;
    padding:10px;
    min-height:50px;
    text-align:center;
    line-height:30px;
    font-weight:400;
  }
  .lead-title{
    margin:150px 0 30px 0;
    font-size:40px;
  }
  .sub-lead-title{
    max-width:650px;
    line-height:30px;
    margin-bottom:30px;
    color:#c6c6c6;
  }
  .lead-btn{
    margin-top:15px;
    padding:10px;
    width:190px;
    min-height:30px;
    font-size:20px;
    text-align:center;
    letter-spacing:3px;
    line-height:30px;
    background-color:#d983a6;
    border-radius:5px;
    transition:all 0.5s ease;
    cursor:pointer;
  }
  .lead-btn:hover{
    background-color:#ffffff;
    color:#4c114e;
  }
  .lead-btn:active{
    background-color:#4d114f;
    color:#fff;
  }
  .flex-sect{
    background-color:#fafafa;
    padding:100px 0;
    font-family:Helvetica, serif;
  }
  .flex-title{
    margin-bottom:15px;
    font-size:2em;
    text-align:center;
    font-weight:700;
    color:#555;
    padding:5px;
  }
  .flex-desc{
    margin-bottom:55px;
    font-size:1em;
    color:rgba(0, 0, 0, 0.5);
    text-align:center;
    padding:5px;
  }
  .cards{
    padding:20px 0;
    display:flex;
    justify-content:space-around;
    flex-flow:wrap;
  }
  .card{
    background-color:white;
    height:300px;
    width:300px;
    margin-bottom:30px;
    box-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.2);
    border-radius:2px;
    transition:all 0.5s ease;
    font-weight:100;
    overflow:hidden;
  }
  .card:hover{
    margin-top:-5px;
    box-shadow:0 20px 30px 0 rgba(0, 0, 0, 0.2);
  }
  .card-header{
    height:155px;
    background-image:url("https://via.placeholder.com/350x250/78c5d6/fff");
    background-size:cover;
    background-position:center center;
  }
  .card-header.ch2{
    background-image:url("https://via.placeholder.com/350x250/459ba8/fff");
  }
  .card-header.ch3{
    background-image:url("https://via.placeholder.com/350x250/79c267/fff");
  }
  .card-header.ch4{
    background-image:url("https://via.placeholder.com/350x250/c5d647/fff");
  }
  .card-header.ch5{
    background-image:url("https://via.placeholder.com/350x250/f28c33/fff");
  }
  .card-header.ch6{
    background-image:url("https://via.placeholder.com/350x250/e868a2/fff");
  }
  .card-body{
    padding:15px 15px 5px 15px;
    color:#555;
  }
  .card-title{
    font-size:1.4em;
    margin-bottom:5px;
  }
  .card-sub-title{
    color:#b3b3b3;
    font-size:1em;
    margin-bottom:15px;
  }
  .card-desc{
    font-size:0.85rem;
    line-height:17px;
  }
  .am-sect{
    padding-top:100px;
    padding-bottom:100px;
    font-family:Helvetica, serif;
  }
  .img-phone{
    float:left;
  }
  .am-container{
    display:flex;
    flex-wrap:wrap;
    align-items:center;
    justify-content:space-around;
  }
  .am-content{
    float:left;
    padding:7px;
    width:490px;
    color:#444;
    font-weight:100;
    margin-top:50px;
  }
  .am-pre{
    padding:7px;
    color:#b1b1b1;
    font-size:15px;
  }
  .am-title{
    padding:7px;
    font-size:25px;
    font-weight:400;
  }
  .am-desc{
    padding:7px;
    font-size:17px;
    line-height:25px;
  }
  .am-post{
    padding:7px;
    line-height:25px;
    font-size:13px;
  }
  .blk-sect{
    padding-top:100px;
    padding-bottom:100px;
    background-color:#222222;
    font-family:Helvetica, serif;
  }
  .blk-title{
    color:#fff;
    font-size:25px;
    text-align:center;
    margin-bottom:15px;
  }
  .blk-desc{
    color:#b1b1b1;
    font-size:15px;
    text-align:center;
    max-width:700px;
    margin:0 auto;
    font-weight:100;
  }
  .price-cards{
    margin-top:70px;
    display:flex;
    flex-wrap:wrap;
    align-items:center;
    justify-content:space-around;
  }
  .price-card-cont{
    width:300px;
    padding:7px;
    float:left;
  }
  .price-card{
    margin:0 auto;
    min-height:350px;
    background-color:#d983a6;
    border-radius:5px;
    font-weight:100;
    color:#fff;
    width:90%;
  }
  .pc-title{
    font-weight:100;
    letter-spacing:3px;
    text-align:center;
    font-size:25px;
    background-color:rgba(0, 0, 0, 0.1);
    padding:20px;
  }
  .pc-desc{
    padding:75px 0;
    text-align:center;
  }
  .pc-feature{
    color:rgba(255,255,255,0.5);
    background-color:rgba(0, 0, 0, 0.1);
    letter-spacing:2px;
    font-size:15px;
    padding:10px 20px;
  }
  .pc-feature:nth-of-type(2n){
    background-color:transparent;
  }
  .pc-amount{
    background-color:rgba(0, 0, 0, 0.1);
    font-size:35px;
    text-align:center;
    padding:35px 0;
  }
  .pc-regular{
    background-color:#da78a0;
  }
  .pc-enterprise{
    background-color:#d66a96;
  }
  .footer-under{
    background-color:#312833;
    padding-bottom:100px;
    padding-top:100px;
    min-height:500px;
    color:#eee;
    position:relative;
    font-weight:100;
    font-family:Helvetica,serif;
  }
  .copyright{
    background-color:rgba(0, 0, 0, 0.15);
    color:rgba(238, 238, 238, 0.5);
    bottom:0;
    padding:1em 0;
    position:absolute;
    width:100%;
    font-size:0.75em;
  }
  .made-with{
    float:left;
    width:50%;
    padding:5px 0;
  }
  .foot-social-btns{
    display:none;
    float:right;
    width:50%;
    text-align:right;
    padding:5px 0;
  }
  .footer-container{
    display:flex;
    flex-wrap:wrap;
    align-items:stretch;
    justify-content:space-around;
  }
  .foot-list{
    float:left;
    width:200px;
  }
  .foot-list-title{
    font-weight:400;
    margin-bottom:10px;
    padding:0.5em 0;
  }
  .foot-list-item{
    color:rgba(238, 238, 238, 0.8);
    font-size:0.8em;
    padding:0.5em 0;
  }
  .foot-list-item:hover{
    color:rgba(238, 238, 238, 1);
  }
  .foot-form-cont{
    width:300px;
    float:right;
  }
  .foot-form-title{
    color:rgba(255,255,255,0.75);
    font-weight:400;
    margin-bottom:10px;
    padding:0.5em 0;
    text-align:right;
    font-size:2em;
  }
  .foot-form-desc{
    font-size:0.8em;
    color:rgba(255,255,255,0.55);
    line-height:20px;
    text-align:right;
    margin-bottom:15px;
  }
  .sub-input{
    width:100%;
    margin-bottom:15px;
    padding:7px 10px;
    border-radius:2px;
    color:#fff;
    background-color:#554c57;
    border:none;
  }
  .sub-btn{
    width:100%;
    margin:15px 0;
    background-color:#785580;
    border:none;
    color:#fff;
    border-radius:2px;
    padding:7px 10px;
    font-size:1em;
    cursor:pointer;
  }
  .sub-btn:hover{
    background-color:#91699a;
  }
  .sub-btn:active{
    background-color:#573f5c;
  }
  .bdg-sect{
    padding-top:100px;
    padding-bottom:100px;
    font-family:Helvetica, serif;
    background-color:#fafafa;
  }
  .bdg-title{
    text-align:center;
    font-size:2em;
    margin-bottom:55px;
    color:#555555;
  }
  .badges{
    padding:20px;
    display:flex;
    justify-content:space-around;
    align-items:flex-start;
    flex-wrap:wrap;
  }
  .badge{
    width:290px;
    font-family:Helvetica, serif;
    background-color:white;
    margin-bottom:30px;
    box-shadow:0 2px 2px 0 rgba(0, 0, 0, 0.2);
    border-radius:3px;
    font-weight:100;
    overflow:hidden;
    text-align:center;
  }
  .badge-header{
    height:115px;
    background-image:url("/assets/images/demos/bg-gr-v.png"), url("/assets/images/demos/work-desk.jpg");
    background-position:left top, center center;
    background-attachment:scroll, fixed;
    overflow:hidden;
  }
  .badge-name{
    font-size:1.4em;
    margin-bottom:5px;
  }
  .badge-role{
    color:#777;
    font-size:1em;
    margin-bottom:25px;
  }
  .badge-desc{
    font-size:0.85rem;
    line-height:20px;
  }
  .badge-avatar{
    width:100px;
    height:100px;
    border-radius:100%;
    border:5px solid #fff;
    box-shadow:0 1px 1px 0 rgba(0, 0, 0, 0.2);
    margin-top:-75px;
    position:relative;
  }
  .badge-body{
    margin:35px 10px;
  }
  .badge-foot{
    color:#fff;
    background-color:#a290a5;
    padding-top:13px;
    padding-bottom:13px;
    display:flex;
    justify-content:center;
  }
  .badge-link{
    height:35px;
    width:35px;
    line-height:35px;
    font-weight:700;
    background-color:#fff;
    color:#a290a5;
    display:block;
    border-radius:100%;
    margin:0 10px;
  }
  @media (max-width: 768px){
    .foot-form-cont{
      width:400px;
    }
    .foot-form-title{
      width:autopx;
    }
  }
  @media (max-width: 480px){
    .foot-lists{
      display:none;
    }
  }
</style>`,
	},
};

export default landingPages;
